import { loadStripe, Stripe } from '@stripe/stripe-js'

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY

let stripePromise: Promise<Stripe | null> | null = null

/**
 * Stripe.js is fetched lazily — only when a wallet row actually renders, and only when a
 * publishable key is configured. An unset key means no wallet buttons anywhere, never a
 * broken page: every plan keeps its normal button into hosted Checkout.
 */
export const getStripe = (): Promise<Stripe | null> | null => {
  if (!publishableKey) return null
  if (!stripePromise) stripePromise = loadStripe(publishableKey)
  return stripePromise
}

/**
 * Cheap pre-flight so we don't mint a Checkout Session for a browser that can't show a wallet
 * at all (Firefox desktop, older browsers). Apple Pay exposes ApplePaySession; Google Pay rides
 * on the Payment Request API. This is a filter, not a verdict — the element's own `ready` event
 * is what finally decides whether any button is shown.
 */
export const walletsPossible = (): boolean => {
  if (typeof window === 'undefined') return false
  const applePay = (window as any).ApplePaySession
  if (applePay?.canMakePayments?.()) return true
  return typeof (window as any).PaymentRequest === 'function'
}
